/**
 * Shared guard for map interaction event handlers.
 *
 * Any window-level listener that controls the map/globe should call
 * isUIEvent(event) first and bail out if it returns true.  This ensures
 * that clicks/taps/moves that originate from the sidebar, nav panel,
 * country modal, or any other UI overlay are never misinterpreted as
 * map interactions — regardless of whether those elements visually
 * overlap the canvas.
 */

const UI_SELECTOR = [
    '#sidebar-container',
    '#nav-container',
    '#country-modal',
    'button',
    'input',
    'select',
    'a',
    'label',
    '[role="button"]',
].join(', ');

/**
 * Returns true when the event originated inside a UI overlay element.
 * @param {Event} event
 */
export const isUIEvent = (event) => !!event.target.closest(UI_SELECTOR);
